import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { UserRepository } from '../../../core/repositories/auth/UserRepository';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/auth/service/auth.service';
import {
  LoginDTO,
  LoginResponseDTO,
  RecoveryRequestDTO,
  RecoveryResponseDTO,
  ChangePassRequestDTO,
  ChangePassResponseDTO,
  ChangeProfileRequestDTO,
  ChangeProfileResponseDTO,
  AdminsDTO,
} from '../../dto/LoginDTO';
import { WhatsappCodeRequest } from 'src/app/models/auth/login/whatsapp-code-request.model';
import { WhatsappCodeResponse } from 'src/app/models/auth/login/whatsapp-code-response.model';
import { LoginPhoneRequest } from 'src/app/models/auth/login/login-phone-request.model';
import { LoginPhoneResponse } from 'src/app/models/auth/login/login-phone-response.model';
import { CompleteProfileRequest } from 'src/app/models/auth/login/complete-profile-request.model';
import { CompleteProfileResponse } from 'src/app/models/auth/login/complete-profile-response.model';
import { ApiResponse, NetworkService } from 'src/app/auth/utils/NetworkService';

@Injectable({
  providedIn: 'root',
})
export class UserRestRepository extends UserRepository {
  private headers: HttpHeaders;
  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private networkService: NetworkService
  ) {
    super();
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  login(auth: LoginDTO): Observable<LoginResponseDTO> {
    const endpoint = environment.auth.login;
    const httpOptions = { headers: this.headers };
    return this.http
      .post<LoginDTO>(`${environment.url_base}/${endpoint}`, auth, httpOptions)
      .pipe(
        map((user) => {
          return this.auth.login(user);
        })
      );
  }

  logout(): Observable<string> {
    this.auth.logout();
    const subjet = new BehaviorSubject<string>('login');
    return subjet.asObservable();
  }

  recover(request: RecoveryRequestDTO): Observable<RecoveryResponseDTO> {
    const endpoint = environment.auth.recover_user;
    const httpOptions = { headers: this.headers };
    return this.http
      .post<RecoveryResponseDTO>(
        `${environment.url_base}/${endpoint}`,
        JSON.stringify(request),
        httpOptions
      )
      .pipe(
        map((result) => {
          return result;
        })
      );
  }

  recoverWati(request: RecoveryRequestDTO): Observable<RecoveryResponseDTO> {
    const endpoint = environment.auth.recover_wati_user;
    const httpOptions = { headers: this.headers };
    return this.http
      .post<RecoveryResponseDTO>(
        `${environment.url_base}/${endpoint}`,
        JSON.stringify(request),
        httpOptions
      )
      .pipe(
        map((result) => {
          return result;
        })
      );
  }

  changePass(request: ChangePassRequestDTO): Observable<ChangePassResponseDTO> {
    const endpoint = environment.auth.change_password;
    const httpOptions = { headers: this.headers };
    return this.http
      .post<ChangePassResponseDTO>(
        `${environment.url_base}/${endpoint}`,
        JSON.stringify(request),
        httpOptions
      )
      .pipe(
        map((result) => {
          return result;
        })
      );
  }

  changeProfile(request: ChangeProfileRequestDTO): Observable<ChangeProfileResponseDTO> {
    const endpoint = environment.change_profile_endpoint;
    const id = request.id;
    const httpOptions = { headers: this.headers };
    return this.http
      .put<ChangeProfileResponseDTO>(
        `${environment.url_base}/${endpoint}/${id}`,
        JSON.stringify(request),
        httpOptions
      )
      .pipe(
        map((result) => {
          return result;
        })
      );
  }

  admins(): Observable<AdminsDTO> {
    const endpoint = environment.auth.only_admins;
    const httpOptions = { headers: this.headers };
    return this.http
      .get<AdminsDTO>(
        `${environment.url_base}/${endpoint}`,
        httpOptions
      )
      .pipe(
        map((result) => {
          return result;
        })
      );
  }

  getCode(request: WhatsappCodeRequest): Observable<WhatsappCodeResponse> {
    const endpoint = environment.auth.get_code;
    const httpOptions = { headers: this.headers };
    return this.http
      .post<WhatsappCodeResponse>(
        `${environment.url_base}/${endpoint}`,
        JSON.stringify(request),
        httpOptions
      )
      .pipe(
        map((result) => {
          return result;
        })
      );
  }

  loginWithPhone(request: LoginPhoneRequest): Observable<ApiResponse<LoginPhoneResponse>> {
    const endpoint = environment.auth.login_with_phone;
    const url = `${environment.url_base}/${endpoint}`;
    return this.networkService.post<LoginPhoneResponse>(
      url,
      request,
      this.networkService.getPublicHeaders()
    );
  }

  registerOneTime(request: WhatsappCodeRequest): Observable<WhatsappCodeResponse> {
    const endpoint = environment.auth.register_one_time;
    const httpOptions = { headers: this.headers };
    return this.http
      .post<WhatsappCodeResponse>(
        `${environment.url_base}/${endpoint}`,
        JSON.stringify(request),
        httpOptions
      )
      .pipe(
        map((result) => {
          return result;
        })
      );
  }

  completeOneTimeProfile(request: CompleteProfileRequest): Observable<CompleteProfileResponse> {
    const endpoint = environment.auth.complete_one_time_profile;
    const httpOptions = { headers: this.headers };
    return this.http
      .post<CompleteProfileResponse>(
        `${environment.url_base}/${endpoint}`,
        JSON.stringify(request),
        httpOptions
      )
      .pipe(
        map((result) => {
          return result;
        })
      );
  }

}
